export enum PeriodType {
    Yearly = 1,
    Monthly = 2
}
